module.exports = __webpack_public_path__ + "static/media/logo500.ee801586.png";